const axios = require('axios');

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');
const api_token_input = document.getElementsByName('api_token');
if (api_token_input.length){
    let api_token = api_token_input[0].value;
    if (api_token){
        localStorage.setItem('api_token', api_token);
    }
}

if (token) {
    axios.defaults.headers.common['Content-type'] = "application/x-www-form-urlencoded";
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.axios = axios;
export {axios}